export default __webpack_public_path__ + "static/media/df05a9ddbd0e08c7ca68f187746e5ce61581615195898.ceff7145.webp";